import { akamai } from '../../globals';
const { Map } = window;
const { PlayState, DisplayState } = akamai.amp;
export class AmpEventsState{
	constructor(player){
		this.state = new Map();
		this.state.set("currentTime",player.mediaElement.currentTime);
		this.state.set("duration",player.duration);
		this.state.set("isCcVisible", player.captioning && player.captioning.getHidden()==false);
		this.state.set("isEnded",player.playState === PlayState["ENDED"]);
		this.state.set("isFullscreen",player.displayState === DisplayState["FULL_SCREEN"]);
		this.state.set("isMuted",player.muted);
		this.state.set("isPlaying",player.playState === PlayState["PLAYING"])
		this.state.set("isSeeking",player.seeking);
		this.state.set("volume",player.volume);
		this.state.set("playState",player.playState);
	}

	get currentTime(){
		return this.state.get("currentTime");
	}
	set currentTime(val = 0){
		this.state.set("currentTime",val);
	}
	get duration(){
		return this.state.get("duration");
	}
	set duration(val = 0){
		this.state.set("duration",val);
	}
	get isCcVisible(){
		return this.state.get("isCcVisible");
	}
	set isCcVisible(flag = false){
		this.state.set("isCcVisible",flag);
	}
	get isEnded(){
		return this.state.get("isEnded");
	}
	set isEnded(flag = false){
		this.state.set("isEnded",flag);
	}
	get isFullscreen(){
		return this.state.get("isFullscreen");
	}
	set isFullscreen(flag = false){
		this.state.set("isFullscreen",flag);
	}
	get isMuted(){
		return this.state.get("isMuted");
	}
	set isMuted(flag = false){
		this.state.set("isMuted",flag);
	}

	get isPlaying(){
		return this.state.get("isPlaying");
	}

	set isPlaying(flag = false){
		this.state.set("isPlaying",flag);
	}

	get isSeeking(){
		return this.state.get("isSeeking");
	}

	set isSeeking(flag = false){
		this.state.set("isSeeking",flag);
	}
	get playState() {
		return this.state.get("playState");
	}
	set playState(value = "") {
		this.state.set("playState",value);
	}
	get volume(){
		return this.state.get("volume");
	}

	set volume(val = 0){
		this.state.set("volume",val);
	}
}